module.exports = __webpack_public_path__ + "img/ZG81_05.249b5d5b.jpg";